import { CONTROL_UI_PORTAL_API_PREFIX } from "../../../../src/gateway/control-ui-contract.js";

export type PortalLoginResult =
  | { ok: true }
  | { ok: false; error: "unauthorized" | "portal_disabled" | "network" | "unknown" };

/**
 * POST portal password for the current page origin. Requires the Control UI to be opened from the gateway host (same origin as cookies).
 */
export async function postControlUiPortalLogin(
  password: string,
  username?: string,
): Promise<PortalLoginResult> {
  if (typeof window === "undefined" || typeof fetch !== "function") {
    return { ok: false, error: "network" };
  }
  const url = new URL(`${CONTROL_UI_PORTAL_API_PREFIX}/login`, window.location.origin);
  const payload: { password: string; username?: string } = { password };
  if (username !== undefined) {
    payload.username = username;
  }
  try {
    const res = await fetch(url.toString(), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(payload),
    });
    if (res.ok) {
      return { ok: true };
    }
    let body: unknown;
    try {
      body = await res.json();
    } catch {
      body = undefined;
    }
    const err =
      body && typeof body === "object" && "error" in body && typeof (body as { error: unknown }).error === "string"
        ? (body as { error: string }).error
        : "";
    if (res.status === 401 || err === "unauthorized") {
      return { ok: false, error: "unauthorized" };
    }
    if (res.status === 404 || err === "portal_disabled") {
      return { ok: false, error: "portal_disabled" };
    }
    return { ok: false, error: "unknown" };
  } catch {
    return { ok: false, error: "network" };
  }
}
